import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-number-format-dialog',
  template: `
    <p class="mb-4">Please confirm assumed separators:</p>

    <div class="grid grid-cols-2 gap-4 mb-2">
      <div>
        <label class="text-sm">Thousands</label>
        <input pInputText [(ngModel)]="thousands" class="w-full" />
      </div>
      <div>
        <label class="text-sm">Decimal</label>
        <input pInputText [(ngModel)]="decimal" class="w-full" />
      </div>
    </div>

    @if (showPpFgDialog) {
      <div>
        <br><br>

        <p class="mb-4">Please select import data:</p>

        <div style="align-content: center;">
          <div>
            <input
              class="radio-input"
              type="radio"
              id="tvdEmw"
              name="ppFgOption"
              value="tvdEmw"
              [(ngModel)]="ppFgOption"
            />
            <label class="pl-2" for="tvdEmw">TVD / EMW</label>
          </div>

          <div class="pt-2">
            <input
              type="radio"
              name="ppFgOption"
              id="tvdPressure"
              value="tvdPressure"
              [(ngModel)]="ppFgOption"
            />
            <label class="pl-2" for="tvdPressure">TVD / Pressure</label>
          </div>

          <div class="pt-2">
            <input
              type="radio"
              name="ppFgOption"
              id="tvdEmwPressure"
              value="tvdEmwPressure"
              [(ngModel)]="ppFgOption"
            />
            <label class="pl-2" for="tvdEmwPressure">TVD / EMW / Pressure</label>
          </div>
        </div>
      </div>
    }

    <div class="flex justify-end gap-2 pt-2">
      <p-button severity="danger" outlined="true" (click)="cancel()">Cancel</p-button>
      <p-button severity="success" outlined="true" (click)="confirm()">Ok</p-button>
    </div>
  `,
  standalone: false
})
export class NumberFormatDialogComponent {
  public thousands = ',';
  public decimal = '.';
  public ppFgOption = 'tvdEmw';
  public showPpFgDialog: boolean;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.showPpFgDialog = config.data?.showPpFgDialog ?? false;
  }

  confirm(): void {
    this.ref.close({ thousands: this.thousands, decimal: this.decimal, ppFgOption: this.ppFgOption });
  }

  cancel(): void {
    this.ref.close(null);
  }
}
